import { StandardEvents } from '@shopify/events';

// Diagnostic storefront events, separate from Clarity's automatically inferred events.
// Shopify owns completed-purchase reporting. No customer data or checkout-page injection.
if (!window.CgauClarityFunnel) {
  window.CgauClarityFunnel = true;
  let consentDenied = false;
  let viewed = false;
  let checkoutAt = 0;
  const handledCartEvents = new WeakSet();

  const allowed = () => {
    if (consentDenied || window.Shopify?.designMode ||
        ['unpublished', 'development'].includes(window.Shopify?.theme?.role) ||
        document.documentElement.dataset.cgauQa === 'true') return false;
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true;
    } catch (_) { return false; }
  };

  const emit = (name) => {
    if (!allowed() || typeof window.clarity !== 'function') return false;
    try { window.clarity('event', name); return true; }
    catch (_) { return false; }
  };

  const productView = () => {
    if (!viewed && document.querySelector('[data-cgau-purchase-brief]')) {
      viewed = emit('cgau_product_view');
    }
  };

  document.addEventListener('visitorConsentCollected', (event) => {
    const consent = event.detail;
    if (consent?.analyticsAllowed === false || consent?.marketingAllowed === false) consentDenied = true;
    else if (consent?.analyticsAllowed === true && consent?.marketingAllowed === true) consentDenied = false;
    productView();
  });

  document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
    if (event.action !== 'add' || !event.promise || handledCartEvents.has(event)) return;
    handledCartEvents.add(event);
    // Do not retain an interaction made before consent or in theme previews.
    if (!allowed()) return;
    try {
      const result = await event.promise;
      if (result?.cart && result?.detail?.didError === false) emit('cgau_cart_add_success');
    } catch (_) { /* A failed cart request is not a successful addition. */ }
  });

  const checkoutIntent = () => {
    const now = Date.now();
    if (now - checkoutAt < 1500) return;
    if (emit('cgau_checkout_intent')) checkoutAt = now;
  };
  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented || event.submitter?.name !== 'checkout') return;
    checkoutIntent();
  });
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    try {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname)) checkoutIntent();
    } catch (_) { /* Ignore non-URL links. */ }
  });

  // Existing Clarity/Shopify integrations load asynchronously. Only the current
  // product view may be retried; cart and checkout interactions are never queued.
  try {
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], productView);
    }
  } catch (_) { /* Missing privacy API fails closed. */ }
  productView();
  let attempts = 0;
  const timer = window.setInterval(() => {
    productView();
    if (viewed || ++attempts >= 20) window.clearInterval(timer);
  }, 500);
}
